/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const scenarioItemSuggestionSchema = z.object({
  confidence: z.number().nullish(),
  estimationId: z.int().nullish(),
  field: z.enum(['ESTIMATION', 'TEAM']),
  id: z.int(),
  itemId: z.int(),
  modelVersion: z.string().nullish(),
  teamId: z.int().nullish(),
});
